import {
	createSlice,
	PayloadAction,
	SliceCaseReducers,
	ValidateSliceCaseReducers,
} from '@reduxjs/toolkit';

export interface GenericState<T> {
    isAuthenticated: boolean;
	data?: T;
	status: 'loading' | 'finished' | 'error' | null;
	error: string | null;
}

export const createGenericSlice = <
	T,
	Reducers extends SliceCaseReducers<GenericState<T>>
>({
	name = '',
	initialState,
	reducers,
}: {
	name: string;
	initialState: GenericState<T>;
	reducers: ValidateSliceCaseReducers<GenericState<T>, Reducers>;
}) => {
	return createSlice({
		name,
		initialState,
		reducers: {
			start: (state) => {
                console.log('loading')
				state.status = 'loading';
				state.error = null;
			},
			success: (state: GenericState<T>, action: PayloadAction<T>) => {
				state.data = action.payload;
				state.status = 'finished';
				state.error = null;
			},
			error: (state, action: PayloadAction<string | null>) => {
				state.status = 'error';
				state.error = action.payload;
			},
			...reducers,
		},
	});
};
